<template>
    <div>
        <div class="card shadow-sm">
            <div class="card-body">
                <h5 class="card-title">
                    {{ $t("pages.account.info.title") }}
                </h5>
                <div class="row">
                    <div class="col-12">
                        <div class="forms-sample">
                            <div class="form-group">
                                <label
                                    for="first_name"
                                    class="font-weight-bolder"
                                    >{{ $t("user.first_name") }}</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    id="first_name"
                                    :placeholder="$t('user.first_name')"
                                    v-model="user.first_name"
                                    :disabled="!editEnabled"
                                    :class="{
                                        disabled: !editEnabled,
                                        'is-invalid': $errors.has('first_name')
                                    }"
                                />
                                <error input="first_name" />
                            </div>

                            <div class="form-group">
                                <label
                                    for="last_name"
                                    class="font-weight-bolder"
                                    >{{ $t("user.first_name") }}</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    id="last_name"
                                    :placeholder="$t('user.last_name')"
                                    v-model="user.last_name"
                                    :disabled="!editEnabled"
                                    :class="{
                                        disabled: !editEnabled,
                                        'is-invalid': $errors.has('last_name')
                                    }"
                                />
                                <error input="last_name" />
                            </div>

                            <div class="form-group">
                                <label for="email" class="font-weight-bolder">{{
                                    $t("user.email")
                                }}</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    id="email"
                                    :placeholder="$t('user.email')"
                                    v-model="user.email"
                                    :disabled="!editEnabled"
                                    :class="{
                                        disabled: !editEnabled,
                                        'is-invalid': $errors.has('email')
                                    }"
                                />
                                <error input="email" />
                            </div>

                            <div class="form-group">
                                <label
                                    for="preferred_language"
                                    class="font-weight-bolder"
                                    >{{ $t("user.preferred_language") }}</label
                                >
                                <select
                                    class="form-control"
                                    id="preferred_language"
                                    :placeholder="$t('user.preferred_language')"
                                    v-model="user.preferred_language"
                                    :disabled="!editEnabled"
                                    :class="{
                                        disabled: !editEnabled,
                                        'is-invalid': $errors.has(
                                            'preferred_language'
                                        )
                                    }"
                                >
                                    <option value="en">
                                        {{ $t("languages.english") }}
                                    </option>
                                    <option value="de">
                                        {{ $t("languages.german") }}
                                    </option>
                                    <option value="lb">
                                        {{ $t("languages.luxembourgish") }}
                                    </option>
                                </select>
                                <error input="preferred_language" />
                            </div>

                            <div class="form-group">
                                <!-- Edit mode -->
                                <button
                                    class="btn btn-gradient-primary"
                                    v-if="editEnabled"
                                    @click="updateUserData"
                                >
                                    {{ $t("actions.save") }}
                                </button>
                                <button
                                    class="btn btn-light ml-2"
                                    @click="editEnabled = false"
                                    v-if="editEnabled"
                                >
                                    {{ $t("actions.cancel") }}
                                </button>

                                <!-- View mode -->
                                <button
                                    class="btn btn-gradient-warning"
                                    @click="editEnabled = true"
                                    v-if="!editEnabled"
                                >
                                    {{ $t("actions.edit") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminUsersRepository from "../../../../repositories/Admin/AdminUsersRepository";
export default {
    name: "UserInformation",
    props: {
        user: {
            type: Object,
            default: null
        },

    },
    data: () => ({
        userCopy: {},
        editEnabled: false
    }),
    watch: {
        editEnabled: function(value) {
            if (!value) {
                if (!this.saved) this.user = { ...this.userCopy };
            }

            if (value) {
                this.userCopy = { ...this.user };
            }
        }
    },
    methods: {
        updateUserData() {
            AdminUsersRepository.updateUser(this.$route.params.user, {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                preferred_language: this.user.preferred_language
            }).then(res => {
                this.saved = true;
                this.editEnabled = false;
                this.getUser();
            });
        }
    }
};
</script>

<style scoped></style>
